import Typekey from '@/userManagement/Typekey';

export default class NotificationType extends Typekey {
  static readonly like = new NotificationType('like', 'Like', '');

  static readonly comment = new NotificationType('comment', 'Comment', '');

  static readonly share = new NotificationType('share', 'Share', '');

  static allNotificationTypes() {
    return [
      NotificationType.like,
      NotificationType.comment,
      NotificationType.share,
    ];
  }
}
